import '@fortawesome/fontawesome-free/css/all.css';

import '../style/Contact.css';
import banner from '../assets/banner.png';

const Contact = () => {
  return (
    <>
      <title>REM Contact</title>
      <meta
        name='description'
        content='Get in touch with Charese REM property management and operations solutions.'
      />
      <div className='contact-container'>
        <div className='contact-alert-banner'>
          <p>⏱️ Response times may be delayed due to holiday season!</p>
        </div>

        <div className='contact-header'>
          <img src={banner} alt='Charese Banner' className='contact-banner' />
          <h1>Get in Touch</h1>
          <p>We'd love to hear from you. Reach out to us anytime!</p>
        </div>

        <div className='contact-content'>
          <div className='contact-card'>
            <div className='contact-method'>
              <a href='mailto:home@charese.ca'>
                <i className='fa-solid fa-envelope contact-icon'></i>
                <h3>Email</h3>
                <div>home@charese.ca</div>
                <p>We'll respond within 24 hours</p>
              </a>
            </div>

            <div className='contact-method'>
              <a href='tel:+17057839327'>
                <i className='fa-solid fa-phone contact-icon'></i>
                <h3>Phone</h3>
                <div>+1 (705) 783-9327</div>
                <p>Monday to Friday, 4pm - 9pm EST</p>
                <p>Weekends, 10am - 9pm EST</p>
              </a>
            </div>
          </div>

          {/* <div className='contact-form-section'>
          <h2>Send us a Message</h2>
          <form className='contact-form'>
            <div className='form-group'>
              <input type='text' placeholder='Your Name' required />
            </div>
            <div className='form-group'>
              <input type='email' placeholder='Your Email' required />
            </div>
            <div className='form-group'>
              <textarea placeholder='Your Message' rows={6} required></textarea>
            </div>
            <button type='submit' className='submit-btn'>
              Send Message
            </button>
          </form>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Contact;
